/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='menuBar'>
        <Image position={[-840, 0]} scale={[3840, 1.002013]} name='bg' src='menu_bg_wide_square' />
        <Text
            position={[27, 175]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 150,
                fontStyle: 'normal',
                fill: '#9B9B9B',
                align: 'left',
                fontWeight: 'bold'
            }}
            maxWidth={1665}
            name='label'
            localeTextID=''
            text='SOUNDS SETTINGS'
        />
    </Sprite>
);
